module.exports = __webpack_public_path__ + "assets/img/shop_btn.2f997d25.png";